import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter);

import Home from '../views/Home.vue'
import AddPostcard from '../views/AddPostcard.vue'
import Postcards from '../views/Postcards.vue'
import UserPostcards from '../views/UserPostcards.vue'
import RandomPostcard from '../views/RandomPostcard.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Settings from '../views/Settings.vue'
import Verified from '../views/Verified.vue'
import NavError from '../views/NavError.vue'

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        // Login Component
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        // SignUp Component
        {
            path: '/signup',
            name: 'sign-up',
            component: SignUp
        },
        // Settings
        {
            path:'/settings',
            name:'settings',
            component: Settings,
            meta: {
                requiresLogin:true
            }
        },
        // Email Verification
        {
            path:'/verified',
            name:'verified',
            component: Verified
        },
        // Home Component
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/',
            redirect: {
                name: 'home'
            }
        },
        // Random Postcards Component
        {
            path: '/postcards/random',
            name: 'postcards',
            component: RandomPostcard
        },
        // Postcards Component
        {
            path: '/postcards/:sort',
            name: 'postcards',
            component: Postcards
        },
        // Postcards Component
        {
            path: '/postcards/by-user/:user_id',
            name: 'user-postcards',
            component: UserPostcards
        },
        // Add Postcard
        {
            path: '/add-postcard',
            name: 'add-postcard',
            component: AddPostcard,
            meta: {
                requiresLogin: true
            }
        },
        // Edit Postcard
        {
            path: '/edit-postcard/:postcard_id',
            name: 'edit-postcard',
            component: AddPostcard,
            meta: {
                requiresLogin: true
            }
        },
        // NavError Component
        {
            path:'*',
            name:'404',
            component: NavError
        }
    ]
});

router.beforeEach((toRoute, fromRoute, next) => {
    let requiresLogin = toRoute.meta.requiresLogin,
        isAuthenticating = store.state.users.userAuthenticating,
        isLoggedIn = store.state.users.userLoggedIn;
    // console.log(`router.beforeEach() requiresLogin [${requiresLogin}] isLoggedIn [${isLoggedIn}] isAuthenticating [${isAuthenticating}]`);
    if (requiresLogin) {
        if (isLoggedIn || isAuthenticating) {
            next();
        } else {
            console.warn(`router.beforeEach() App user is not logged in`);
            next('/login');
        }
    } else {
        next();
    }
});

router.history

export default router